import React, { Component, createRef, Fragment } from 'react';
import Dropzone from 'react-dropzone';

import * as uuid from 'uuid';
import { toaster, Spinner, IconButton } from 'evergreen-ui';

import uploadImage from '../images/upload.png';
import { FileInputStyle } from './style/FileInput';
import fileService from '../../../services/briefing/file';
import api from '../../../services/api';

import '../../../config/ReactotronConfig';

export default class FileInput extends Component {
	acceptSizeFile = process.env.REACT_FILE_MAX_UPLOAD || 20971520;

	constructor(props) {
		super(props);

		this.state = {
			errorMessage: '',
			fileList: [],
			isDeletingKeys: [],
		};

		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.getFileInput = this.getFileInput.bind(this);
		this.getAcceptedFiles = this.getAcceptedFiles.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
	}

	componentWillMount() {
		const {
			valueField,
		} = this.props;

		if (valueField) {
			const { fileList } = this.state;
			valueField.forEach((file) => { fileList[uuid.v4()] = file; });
			this.setState({ fileList });
		}
		return true;
	}

	componentWillReceiveProps(nextProps) {
		const { clearField } = nextProps;

		if (clearField) {
			this.setState({ fileList: [] });
		}
	}

	onChangeHandler = (droppedfiles) => {
		let messageValidation = '';

		this.setState({
			errorMessage: messageValidation,
		});

		droppedfiles.map((file) => {
			messageValidation = this.validateFile(file);
			if (messageValidation) {
				this.setState({ errorMessage: messageValidation });
				toaster.danger(messageValidation);
				return false;
			}
			const { fileList } = this.state;
			const data = new FormData();
			const idx = uuid.v4(3);

			data.append('file', file);

			fileList[idx] = {};
			this.setState({ fileList });

			api.post('/files', data)
				.then((result) => {
					fileList[idx] = result.data.data;
				})
				.catch(() => {
					toaster.danger('Falha ao enviar o arquivo');
					delete fileList[idx];
					this.setState({ fileList });
				})
				.finally(() => this.setState({ fileList }, () => this.buildAndSend()));
			return file;
		});
	};

	getAcceptedFiles(fileList) {
		const keys = Object.keys(fileList);
		const { isDeletingKeys } = this.state;

		if (Object.keys(fileList).length) {
			return keys.map((key) => {
				const file = fileList[key];
				return (
					<li key={key}>
						{file && file.id ? (
							<Fragment>
								<div className="d-flex align-items-center">
									<i className="fa fa-file" aria-hidden="true" />
									<span className="px-2">{file.name} - {fileService.getSizeDescription(file.size)}</span>
									{isDeletingKeys.indexOf(key) === -1 ? (
										<IconButton
											key={key}
											className="ml-auto"
											icon="cross"
											iconSize={20}
											appearance="minimal"
											onClick={() => this.deleteFile(key)}
											is="a"
										/>
									) : (<Spinner className="ml-auto" size={24} />)}
								</div>
							</Fragment>
						) : (<Spinner />)}
						<hr />
					</li>
				);
			});
		}

		return (
			<li>
				*Nenhum arquivo foi enviado
			</li>
		);
	}

	getFileInput() {
		const {
			nameField,
			messageErrorField,
			required,
			meta,
			question,
			classContainer,
		} = this.props;

		const { errorMessage, fileList } = this.state;

		const dropzoneRef = createRef();
		const openDialog = () => {
			if (dropzoneRef.current) {
				dropzoneRef.current.open();
			}
		};

		return (
			<div className={`component-question-data ${classContainer}`}>
				{meta.attention === 'peca-grafica'
					? (
						<div className="attention-box">
							<h3 className="col-12">Atenção!</h3>

							<div className="col-12 attention-content">
								<h4>VOCÊ OPTOU POR ENVIAR AS PEÇAS DA SUA CAMPANHA.</h4>
								<ul>
									<li>
										- Caso não possua as artes no momento, precisamos recebê-las antes de cadastrar
										a sua campanha. Conclua o Briefing e posteriormente envie as artes para:
										gearbox@webmotors.com.br
									</li>
									<li>
										- É proibido inserir dados de contato na peça gráfica,
										de acordo com as politicas externas.
									</li>
									<li>- As peças passarão pela validação do especialista e da plataforma.</li>
								</ul>
							</div>

							<div className="col-12 attention-link">
								*Saiba mais em Gearbox Mídia -
								<a target="_blank" rel="noopener noreferrer" href="http://midias.webmotors.com.br/boaspraticas">Boas práticas</a>
							</div>
						</div>
					)
					: ''}

				{meta.attention === 'logo-loja'
					? (
						<div className="attention-box">
							<h3 className="col-12">Atenção!</h3>

							<div className="col-12 attention-content">
								<h4>REGRAS DE CRIAÇÃO DA PEÇA GRÁFICA:</h4>
								<ul>
									<li>
										- Após a entrega da peça gráfica, SÓ SERÃO PERMITIDAS DUAS REFAÇÕES.
									</li>
									<li>
										- É proibido inserir dados de contato na peça gráfica, de acordo com as
										politícas externas.
									</li>
									<li>
										- Tenha o arquivo do logo da loja em PNG, alta definição e fundo transparente.
										Sem o arquivo com essas especificações sua campanha nas redes socias não poderá
										ser realizada.
									</li>
									<li>
										- Caso queira uma cor ou modelo de veículo que não consta no banco de imagem,
										deverá ser enviado o respectivo no formato alta resolução para o e-mail
										gearbox@webmotors.com.br referenciando no assunto o cód. da pré-venda.
									</li>
								</ul>
							</div>
						</div>
					)
					: ''}

				<p>
					{question}
					{required ? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}
				</p>

				<Dropzone
					ref={dropzoneRef}
					onDrop={droppedfiles => this.onChangeHandler(droppedfiles)}
					noClick
					multiple
					noKeyboard
				>
					{({ getRootProps, getInputProps }) => (
						<div className={`file-drag-drop ${meta.attention === 'annotation' ? 'row' : ''}`}>
							<div className={`align-self-start ${meta.attention === 'annotation' ? 'col-10' : 'col-12 '}`}>
								<ul>
									{this.getAcceptedFiles(fileList)}
								</ul>
							</div>

							<div {...getRootProps(meta.attention !== 'annotation' ? { className: 'col-12 align-self-center dropzone' } : { className: 'col-2' })}>
								<input {...getInputProps({ name: nameField })} />
								{meta.attention !== 'annotation' ? (
									<>
										<div className="arraste-as-imagens">
											<img src={uploadImage} alt="ícone upload" />
											<p>Arraste as imagens aqui</p>
										</div>

										<p>Ou, se preferir</p>
										<button
											type="button"
											className="btn btn-primary"
											onClick={openDialog}
										>
											Escolher Arquivos
										</button>
									</>
								) : (
									<button
										type="button"
										className="btn pull-right"
										onClick={openDialog}
									>
										<i className="fas fa-paperclip icon" />
									</button>
)
								}
							</div>
						</div>
					)
					}
				</Dropzone>

				<div className="help-block">{messageErrorField || errorMessage}</div>
			</div>
		);
	}

	buildAndSend = () => {
		const { fileList } = this.state;
		const { onGetValueField, nameField } = this.props;
		if ('Hooks' in this.props) {
			return onGetValueField(Object.values(fileList));
		}
		return onGetValueField(nameField, Object.values(fileList));
	};

	deleteFile = (key) => {
		const { fileList } = this.state;

		this.setState((state) => {
			const isDeletingKeys = state.isDeletingKeys.concat(key);
			return {
				isDeletingKeys,
			};
		});

		api.delete(`/files/${fileList[key].id}`)
			.then(() => {
				toaster.success('Arquivo deletado com sucesso!');
				delete fileList[key];
			})
			.catch((err) => {
				if (err.response && err.response.status === 404) {
					delete fileList[key];
					toaster.danger('Arquivo inexistente.');
					return;
				}
				toaster.danger('Falha ao deletar arquivo.');
			})
			.finally(() => this.setState({ fileList }, () => this.buildAndSend()));
	};

	validateTypeFile = (file) => {
		if (!fileService.isValidMimeType(file.type)) {
			return ' Tipo de arquivo inválido!';
		}
		return '';
	};

	validateSizeFile = (file) => {
		if (file.size > this.acceptSizeFile) {
			return ' Tamanho máximo de arquivo excedido!';
		}
		return '';
	};

	validateFile = file => this.validateSizeFile(file) + this.validateTypeFile(file);

	render() {
		return (
			<FileInputStyle>
				<div>
					{this.getFileInput()}
				</div>
			</FileInputStyle>
		);
	}
}
